import { Link } from "react-router-dom";
import PageLayout from "@/components/aoria/PageLayout";
import PageHeader from "@/components/aoria/PageHeader";
import Seo from "@/components/aoria/Seo";

/**
 * Page Livre blanc — page d'attente élégante harmonisée avec le reste du site.
 * Icône document repositionnée à gauche au-dessus de l'eyebrow pour conserver
 * la même structure éditoriale que les autres pages internes.
 */
export default function LivreBlanc() {
    return (
        <PageLayout testid="livre-blanc-page">
            <Seo
                title="Livre blanc Aoria · Accessibilité cognitive à l'ère de l'IA"
                description="Le premier livre blanc d'Aoria, consacré à l'accessibilité cognitive à l'ère de l'intelligence artificielle, est en cours de finalisation."
                path="/livre-blanc"
            />
            <PageHeader
                testid="livre-blanc"
                eyebrow="LIVRE BLANC"
                title="Le livre blanc d'Aoria,"
                italic="en cours de finalisation"
                lead="Un document de référence consacré à l'accessibilité cognitive à l'ère numérique, aux opportunités offertes par l'intelligence artificielle, et aux risques de nouvelles formes d'exclusion liées aux usages numériques."
                backdrop="lines"
            >
                {/* Decorative document icon placed above the eyebrow */}
                <svg
                    data-testid="livre-blanc-icon"
                    width="52"
                    height="52"
                    viewBox="0 0 32 32"
                    fill="none"
                    className="text-[#778DA9] mb-10"
                    aria-hidden="true"
                >
                    <rect
                        x="7"
                        y="4"
                        width="18"
                        height="24"
                        stroke="currentColor"
                        strokeWidth="1.4"
                    />
                    <line
                        x1="11"
                        y1="11"
                        x2="21"
                        y2="11"
                        stroke="currentColor"
                        strokeWidth="1.2"
                    />
                    <line
                        x1="11"
                        y1="16"
                        x2="21"
                        y2="16"
                        stroke="currentColor"
                        strokeWidth="1.2"
                    />
                    <line
                        x1="11"
                        y1="21"
                        x2="17"
                        y2="21"
                        stroke="currentColor"
                        strokeWidth="1.2"
                    />
                </svg>
            </PageHeader>

            <section className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 pb-24 md:pb-32">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
                    <div className="lg:col-span-3">
                        <span className="editorial-num text-lg">01</span>
                        <div className="hairline mt-3 pb-3" />
                        <p className="eyebrow mt-4">Statut</p>
                    </div>
                    <div className="lg:col-span-9 max-w-3xl">
                        <p className="text-[#1B263B] text-base md:text-lg leading-relaxed">
                            Le premier livre blanc d'Aoria est actuellement en
                            cours de finalisation. Sa publication interviendra
                            prochainement, en libre accès, en français.
                        </p>
                        <p className="mt-6 text-[#1B263B] text-base md:text-lg leading-relaxed">
                            Pour être prévenu de sa sortie, vous pouvez vous
                            inscrire à la lettre d'information d'Aoria ou nous
                            laisser un message.
                        </p>

                        <div className="mt-10 flex flex-col sm:flex-row gap-4">
                            <Link
                                to="/#participer"
                                data-testid="livre-blanc-cta-newsletter"
                                className="btn-primary rounded-full inline-block px-7 py-3.5 text-sm tracking-[0.15em] uppercase"
                            >
                                Être prévenu
                            </Link>
                            <Link
                                to="/enjeu"
                                data-testid="livre-blanc-cta-enjeux"
                                className="btn-secondary rounded-full inline-block px-7 py-3.5 text-sm tracking-[0.15em] uppercase"
                            >
                                Lire les enjeux
                            </Link>
                        </div>
                    </div>
                </div>

                <p className="mt-20 text-xs tracking-[0.18em] uppercase text-[#5C6B7D]">
                    Version 1 en préparation, publication prévue en 2026
                </p>
            </section>
        </PageLayout>
    );
}
